import { VERIFICATION_STATUS } from '../constants/PlaidRequirement';

export const getPaymentMethodStatuses = (paymentMethods) => {
  return paymentMethods.reduce(
    (acc, pm) => {
      // TM-1109: a bank_account can have `isBankAccountVerificationNeeded=true`
      // even when Stripe reports `paymentMethodStatus="verified"` — most often
      // when a renter's RentalRelationship is repointed at a stale PaymentAccount.
      // Trust the Stripe status: if it's already verified, don't drop into the
      // verification-routes branch (which would otherwise emit a no-op
      // <Redirect> to the current URL and render a blank page).
      const needsVerification =
        pm.accountType === 'bank_account' &&
        pm.isBankAccountVerificationNeeded &&
        pm.paymentMethodStatus !== 'verified';
      if (needsVerification) {
        acc.hasPaymentMethodNeedingVerification = true;
      } else {
        acc.hasVerifiedPaymentMethod = true;
      }
      return acc;
    },
    { hasPaymentMethodNeedingVerification: false, hasVerifiedPaymentMethod: false },
  );
};

export const getVerifiedPaymentMethods = (paymentMethods) => {
  return (
    paymentMethods?.filter(
      (paymentMethod) =>
        paymentMethod.paymentMethodStatus === 'verified' ||
        paymentMethod.paymentMethodStatus === VERIFICATION_STATUS.PLAID_REVOKED,
    ) || []
  );
};
